import React, { useState, useEffect } from "react";
import {
  Box,
  Autocomplete,
  TextField,
  Button,
  Stepper,
  Step,
  StepLabel,
  Typography,
  Paper,
  Container,
  CircularProgress,
  Alert,
  Stack,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  TableContainer,
  Table,
  TableHead,
  TableCell,
  TableBody,
  TableRow,
} from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import marketplacesService from "../services/marketplacesService";
import ecommercePlaceService from "../services/ecommercePlaceService";
import categoryService from "../services/categoryService";
import { getMarketPlaces } from "../redux/actions/marketplacesActions";
import { getEcommercePlaces } from "../redux/actions/ecommercePlaceActions";
import productService from "../services/productService";
import ProductSelectionStep from "./UI/reusable-components/SendProductBulkComponents/ProductSelectionStep";
import { fetchPlacesCategory } from "../redux/actions/placesCategoryActions";
import { fetchcategoryAttribute } from "../redux/actions/outWard";
import AttributeSelectionStep from "./UI/reusable-components/SendProductBulkComponents/AttributeSelectionStep";
import LoadingSendProductModal from "./AddProduct/SendProductComponents/loadingSendProductModal";
import outWardService from "../services/outWardService";
import {
  Send as SendIcon,
  Schedule as ScheduleIcon,
  CheckCircle as CheckCircleIcon,
  Info as InfoIcon,
} from "@mui/icons-material";
import { toast } from "react-toastify";
export const SendProductBulk = () => {
  const dispatch = useDispatch();
  const userId = useSelector((state) => state?.auth?.user?.id);
  const token = useSelector((state) => state?.auth?.user?.accessToken?.token);

  const [activeStep, setActiveStep] = useState(0);
  const [allPlaces, setAllPlaces] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedPlace, setSelectedPlace] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [containsTitle, setContainsTitle] = useState("");
  const [loading, setLoading] = useState(true);
  const [loadingSendProduct, setLoadingSendProduct] = useState(true);
  const [loadingOutwardSendProduct, setLoadingOutwardSendProduct] =
    useState(true);
  const [error, setError] = useState(null);
  const [selectSearchTerm, setSelectSearchTerm] = useState("");
  const [selectedProduct, setSelectedProduct] = useState([]);
  const [products, setProducts] = useState([]);
  const [selectedPlacesCategory, setSelectedPlacesCategory] = useState({});
  const [ecommerceAccounts, setEcommerceAllAccounts] = useState([]);
  const [marketpleacesAccounts, setMarketpleacesAllAccounts] = useState([]);
  const [outWardCategoryAttribute, setOutWardCategoryAttribute] =useState(null);
  const [selectedAttributes, setSelectedAttributes] = useState([]);
  const [accountMarketpleacesName, setAccountMarketpleacesName] = useState({});
  const [openLoadingModal, setOpenLoadingModal] = useState(false);
  const [sendProductResponse, setSendProductResponse] = useState(null);
  const [sendProducts, setSendProducts] = useState(null);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const steps = [
    "Pazaryeri & Kategori Seçimi",
    "Ürün seçimi",
    "Özellik seçimi",
    "Ürün Gönder",
  ];
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [bacgroundModal, setbacgroundModal] = useState(false);
  const [loadingBacgroundProduct, setLoadingBacgroundProduct] = useState(false);
  const [categoryAttribute, setCategoryAttribute] = useState([]);
  const [attributeLoading, setAttributeLoading] = useState(false);
  useEffect(() => {
    const fetchAccounts = async () => {
      setLoading(true);
      try {
        const response = await marketplacesService.getMarketPlacesAccountsApi(
          userId,
          token
        );
        setMarketpleacesAllAccounts(response?.data?.data?.data);
        const uniqueMarketPlaceNames = [
          ...new Set(
            response?.data?.data?.data.map((item) => item?.marketPlaceName)
          ),
        ];
        setAccountMarketpleacesName(uniqueMarketPlaceNames);
        setLoading(false);
      } catch (err) {
        setError(
          err.response?.data?.message ||
            "Hesap bilgileri alınırken hata oluştu."
        );
        setLoading(false);
      }
    };

    const fetchAccountsEcommerce = async () => {
      setLoading(true);
      try {
        const response =
          await ecommercePlaceService.getEcommercePlaceAccountsApi(
            userId,
            token
          );
        setEcommerceAllAccounts(response?.data?.data?.data);
        setLoading(false);
      } catch (err) {
        setError(
          err.response?.data?.message ||
            "Hesap bilgileri alınırken hata oluştu."
        );
        setLoading(false);
      }
    };
    fetchAccounts();
    fetchAccountsEcommerce();
  }, [userId]);

  useEffect(() => {
    const fetchPlatforms = async () => {
      try {
        const [marketResponse, ecommerceResponse] = await Promise.all([
          dispatch(getMarketPlaces(token)),
          dispatch(getEcommercePlaces(token)),
        ]);
        const combinedData = [
          ...marketResponse.data.map((item) => ({
            ...item,
            type: "marketplace",
          })),
          ...ecommerceResponse.data.map((item) => ({
            ...item,
            type: "ecommerce",
          })),
        ];
        setAllPlaces(combinedData);
      } catch (err) {
        setError(err.message || "Veriler alınırken hata oluştu.");
      }
    };
    fetchPlatforms();
  }, [dispatch, token]);

  useEffect(() => {
    console.log("pageSize değişti:", pageSize);
    if (selectedCategory?.id) {
      getCategoryProducts();
    }
  }, [pageSize]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const fetchedCategories =
          await categoryService.getCategoriesApiForDropdown(
            token,
            1,
            selectSearchTerm,
            userId
          );
        setCategories(fetchedCategories.data?.data?.data);
      } catch (error) {
        console.error("Kategoriler alınırken hata oluştu:", error);
      }
    };
    fetchCategories();
  }, [token, selectSearchTerm, userId]);

  const handleNext = () =>
    activeStep < steps.length - 1 && setActiveStep((prev) => prev + 1);
  const handleBack = () => activeStep > 0 && setActiveStep((prev) => prev - 1);
  const canProceedToNextStep = selectedPlace; //&& selectedCategory;

  const handleInputChange = (e) => {
    setContainsTitle(e.target.value);
  };

  const getCategoryProducts = async () => {
    try {
      setLoading(true);
      let marketPlaceId = null;
      let ecommercePlaceId = null;

      if (selectedPlace?.type === "ecommerce") {
        ecommercePlaceId = selectedPlace?.id;
      } else {
        marketPlaceId = selectedPlace?.id;
      }

      const result = await productService.getCategoryProducts(
        selectedCategory?.id,
        userId,
        page,
        marketPlaceId,
        ecommercePlaceId,
        pageSize,
        containsTitle
      );
      setTotalCount(result?.recordsTotal);
      setProducts(result?.data || []);
      getPlaceCategory();

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching products:", error);
    } finally {
      setLoading(false);
    }
  };
  const getPlaceCategory = async () => {
    try {
      setLoading(true);
      const queryModel = {};
      queryModel.categoryId = selectedCategory?.id;
      if (selectedPlace?.id == null) {
        return;
      }
      if (selectedPlace?.type === "ecommerce") {
        queryModel.ecommercePlaceId = selectedPlace?.id;
      } else {
        queryModel.marketPlaceId = selectedPlace?.id;
      }
      const response = await dispatch(fetchPlacesCategory(queryModel));
      setSelectedPlacesCategory(response?.data[0]);
      getCategoryAttribute(response?.data[0]?.marketPlaceCategoryId);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching products:", error);
    }
  };

  const getCategoryAttribute = async (marketPlaceCategoryId) => {
    setOutWardCategoryAttribute(null);
    const categoryId = marketPlaceCategoryId;

    if (selectedPlace?.name == null) {
      return;
    }
    if (categoryId == null) {
      return;
    }

    const requestBody = createRequestBodyAttribute(
      categoryId,
      selectedPlace?.name,
      "2024-11-01T13:17:58.526Z",
      "2024-11-16T13:17:58.526Z"
    );
    try {
      setAttributeLoading(true);
      const response = await outWardService.fetchCategoryAttribute(
        selectedPlace?.name,
        requestBody,
        token
      );
      setCategoryAttribute(response);
      setAttributeLoading(false);
    } catch (error) {
      setAttributeLoading(false);
      console.error(
        "API Hatası:",
        error.response ? error.response.data : error.message
      );
    } finally {
      setLoading(false);
    }
  };

  const createRequestBodyAttribute = (
    categoryId,
    selectedPlaceName,
    startDate,
    endDate,
    page = 0,
    size = 5
  ) => {
    const marketPlaceSettings = marketpleacesAccounts
      .filter((account) => account.marketPlaceName === selectedPlaceName)
      .map((account) => ({
        id: 0,
        userId: account.userId,
        marketPlaceId: account.marketPlaceId || 0,
        marketPlaceName: account.marketPlaceName,
        valueId: account.valueId,
        value: account.value,
        createDate: new Date().toISOString(),
        updateDate: new Date().toISOString(),
        ia: true,
      }));

    const ecommercePlaceSettings = ecommerceAccounts
      .filter((account) => account.ecommercePlaceName === selectedPlaceName)
      .map((account) => ({
        id: 0,
        userId: account.userId,
        ecommercePlaceId: account.ecommercePlaceId || 0,
        ecommercePlaceName: account.ecommercePlaceName,
        valueId: account.valueId,
        value: account.value,
        createDate: new Date().toISOString(),
        updateDate: new Date().toISOString(),
        ia: true,
      }));

    return {
      categoriId: categoryId,
      userId: userId,
      marketPlaceSetting: marketPlaceSettings,
      ecommercePlaceSettings: ecommercePlaceSettings,
      startDate: startDate || new Date().toISOString(),
      endDate: endDate || new Date().toISOString(),
      page: page,
      size: size,
    };
  };

  const createRequestBodySendProduct = (
    sendOutwadrProducts,
    selectedPlaceName,
    startDate,
    endDate,
    page = 0,
    size = 100
  ) => {
    const marketPlaceSettings = marketpleacesAccounts
      .filter((account) => account.marketPlaceName === selectedPlaceName)
      .map((account) => ({
        id: 0,
        userId: account.userId,
        marketPlaceId: account.marketPlaceId || 0,
        marketPlaceName: account.marketPlaceName,
        valueId: account.valueId,
        value: account.value,
        createDate: new Date().toISOString(),
        updateDate: new Date().toISOString(),
        ia: true,
      }));

    const ecommercePlaceSettings = ecommerceAccounts
      .filter((account) => account.ecommercePlaceName === selectedPlaceName)
      .map((account) => ({
        id: 0,
        userId: account.userId,
        ecommercePlaceId: account.ecommercePlaceId || 0,
        ecommercePlaceName: account.ecommercePlaceName,
        valueId: account.valueId,
        value: account.value,
        createDate: new Date().toISOString(),
        updateDate: new Date().toISOString(),
        ia: true,
      }));

    return {
      userId: userId,
      marketPlaceSetting: marketPlaceSettings,
      ecommercePlaceSettings: ecommercePlaceSettings,
      startDate: startDate || new Date().toISOString(),
      endDate: endDate || new Date().toISOString(),
      page: page,
      size: size,
      productRD: [sendOutwadrProducts],
    };
  };
  const createRequestBodyEcommerceSendProduct = (
    sendOutwadrProducts,
    selectedPlaceName,
    startDate,
    endDate,
    page = 0,
    size = 100
  ) => {
    const marketPlaceSettings = marketpleacesAccounts
      .filter((account) => account.marketPlaceName === selectedPlaceName)
      .map((account) => ({
        id: 0,
        userId: account.userId,
        marketPlaceId: account.marketPlaceId || 0,
        marketPlaceName: account.marketPlaceName,
        valueId: account.valueId,
        value: account.value,
        createDate: new Date().toISOString(),
        updateDate: new Date().toISOString(),
        ia: true,
      }));

    const ecommercePlaceSettings = ecommerceAccounts
      .filter((account) => account.ecommercePlaceName === selectedPlaceName)
      .map((account) => ({
        id: 0,
        userId: account.userId,
        ecommercePlaceId: account.ecommercePlaceId || 0,
        ecommercePlaceName: account.ecommercePlaceName,
        valueId: account.valueId,
        value: account.value,
        createDate: new Date().toISOString(),
        updateDate: new Date().toISOString(),
        ia: true,
      }));

    return {
      userId: userId,
      marketPlaceSetting: marketPlaceSettings,
      ecommercePlaceSettings: ecommercePlaceSettings,
      startDate: startDate || new Date().toISOString(),
      endDate: endDate || new Date().toISOString(),
      page: page,
      size: size,
      productRD: sendOutwadrProducts,
    };
  };
  const senProduct = async () => {
    try {
      setLoadingOutwardSendProduct(true);
      setLoadingSendProduct(true);
      setOpenLoadingModal(true);

      const productAttributesNested = selectedProduct?.map((id) => {
        const data = {
          productId: id,
          attributeValue: selectedAttributes,
        };
        return transformProductDataToList(data, userId);
      });

      const productAttributes = productAttributesNested.flat();

      if (productAttributes?.length > 0) {
        await productService.sendProduct(productAttributes, token);
      }

      const response = await productService.getOutwardSendProducts(
        selectedProduct,
        selectedPlace?.id,
        token,
        selectedPlace?.type,
        selectedCategory?.id
      );

      if (response?.data) {
        setLoadingOutwardSendProduct(false);
        setSendProducts(response.data);

        if (selectedPlace?.name === "Ciceksepeti") {
          const responseData = response.data || [];
          for (const element of responseData) {
            const requestBody = createRequestBodySendProduct(
              element,
              selectedPlace?.name,
              "2024-11-01T13:17:58.526Z",
              "2024-11-16T13:17:58.526Z"
            );
            const sendResponse = await outWardService.sendProduct(
              selectedPlace?.name,
              requestBody,
              token,
              selectedPlace?.type
            );
            setSendProductResponse(sendResponse);
          }
          await new Promise((resolve) => setTimeout(resolve, 5000));
        } else if (selectedPlace?.type === "ecommerce") {
          const responseData = response.data || [];
          const groupedProducts = {};

          responseData.forEach((product) => {
            const mainId = product.productMainId;
            if (!groupedProducts[mainId]) {
              groupedProducts[mainId] = [];
            }
            groupedProducts[mainId].push(product);
          });

          for (const mainId in groupedProducts) {
            const productsWithSameMainId = groupedProducts[mainId];
            const requestBody = createRequestBodyEcommerceSendProduct(
              productsWithSameMainId,
              selectedPlace?.name,
              "2024-11-01T13:17:58.526Z",
              "2024-11-16T13:17:58.526Z"
            );

            const sendResponse = await outWardService.sendProduct(
              selectedPlace?.name,
              requestBody,
              token,
              selectedPlace?.type
            );
            setSendProductResponse(sendResponse);
          }
        } else {
          const responseData = response.data || [];
          for (const element of responseData) {
            const requestBody = createRequestBodySendProduct(
              element,
              selectedPlace?.name,
              "2024-11-01T13:17:58.526Z",
              "2024-11-16T13:17:58.526Z"
            );
            const sendResponse = await outWardService.sendProduct(
              selectedPlace?.name,
              requestBody,
              token,
              selectedPlace?.type
            );
            setSendProductResponse(sendResponse);
          }
        }
      }
      setSelectedProducts([]);
      setLoadingOutwardSendProduct(false);
      setLoading(false);
      setLoadingSendProduct(false);
    } catch (exx) {
      console.error("Ürün gönderme hatası:", exx);
      setLoadingOutwardSendProduct(false);
      setLoadingSendProduct(false);
      setLoading(false);
      toast.error(
        "Ürünler gönderilirken bir hata oluştu. Lütfen tekrar deneyin."
      );
    }
  };
  const backGroundSenProduct = async () => {
    try {
      setLoadingBacgroundProduct(true);

      const productAttributesNested = selectedProduct?.map((id) => {
        const data = {
          productId: id,
          attributeValue: selectedAttributes,
        };
        return transformProductDataToList(data, userId);
      });

      const productAttributes = productAttributesNested.flat();

      if (productAttributes?.length > 0) {
        await productService.sendProduct(productAttributes, token);
      }

      const response = await productService.getOutwardSendProducts(
        selectedProduct,
        selectedPlace?.id,
        token,
        selectedPlace?.type,
        selectedCategory?.id
      );

      if (response?.data) {
        setLoadingOutwardSendProduct(false);
        setSendProducts(response.data);

        if (selectedPlace?.name === "Ciceksepeti") {
          const responseData = response.data || [];
          for (const element of responseData) {
            const requestBody = createRequestBodySendProduct(
              element,
              selectedPlace?.name,
              "2024-11-01T13:17:58.526Z",
              "2024-11-16T13:17:58.526Z"
            );
            const sendResponse = await outWardService.sendProductBackground(
              selectedPlace?.name,
              requestBody,
              token,
              selectedPlace?.type
            );
            setSendProductResponse(sendResponse);
          }
          await new Promise((resolve) => setTimeout(resolve, 5000));
        } else if (selectedPlace?.type === "ecommerce") {
          const responseData = response.data || [];
          const groupedProducts = {};

          responseData.forEach((product) => {
            const mainId = product.productMainId;
            if (!groupedProducts[mainId]) {
              groupedProducts[mainId] = [];
            }
            groupedProducts[mainId].push(product);
          });

          for (const mainId in groupedProducts) {
            const productsWithSameMainId = groupedProducts[mainId];
            const requestBody = createRequestBodyEcommerceSendProduct(
              productsWithSameMainId,
              selectedPlace?.name,
              "2024-11-01T13:17:58.526Z",
              "2024-11-16T13:17:58.526Z"
            );

            const sendResponse = await outWardService.sendProductBackground(
              selectedPlace?.name,
              requestBody,
              token,
              selectedPlace?.type
            );
            setSendProductResponse(sendResponse);
          }
        } else {
          const responseData = response.data || [];
          for (const element of responseData) {
            const requestBody = createRequestBodySendProduct(
              element,
              selectedPlace?.name,
              "2024-11-01T13:17:58.526Z",
              "2024-11-16T13:17:58.526Z"
            );
            const sendResponse = await outWardService.sendProductBackground(
              selectedPlace?.name,
              requestBody,
              token,
              selectedPlace?.type
            );
            setSendProductResponse(sendResponse);
          }
        }
      }
      setSelectedProducts([]);
      setLoadingBacgroundProduct(false);
      toast.success(
        "Ürünler arka planda gönderilmeye başladı. Gönderim durumunu ürün listesinde takip edebilirsiniz."
      );
    } catch (exx) {
      console.error("Arka plan ürün gönderme hatası:", exx);
      setSendProductResponse(null);
      toast.error(
        "Ürünler gönderilirken bir hata oluştu. Lütfen tekrar deneyin."
      );
      setLoadingBacgroundProduct(false);
    }
  };

  const bacgroundModalClose = () => {
    setbacgroundModal(false);
  };
  const openBackGroundModal = () => {
    setbacgroundModal(true);
  };
  const finish = () => {
    window.location.reload();
  };
  function transformProductDataToList(rawData, userId) {
    const productAttributeList = rawData?.attributeValue?.map((attr) => {
      const isValueObject = typeof attr?.value === "object";
      return {
        Id: 0,
        ProductId: rawData?.productId,
        Varyantible: attr?.attribute?.varianter,
        MarketPlaceId: selectedPlace?.id,
        CreateDate: new Date().toISOString(),
        UpdateDate: new Date().toISOString(),
        Ia: true,
        AttributeValueId: isValueObject ? parseInt(attr?.value?.id) : 0,
        AttributeValue: {
          Id: 0,
          AttributeId: parseInt(attr?.attribute?.id),
          Name: isValueObject ? attr?.value?.name : attr?.value, // String veya nesne durumu
          MapAttrVName: isValueObject ? attr?.value?.name : attr?.value,
          MapAttrVId: isValueObject ? attr?.value?.id : null,
          CreateDate: new Date().toISOString(),
          UpdateDate: new Date().toISOString(),
          Ia: true,
          Attribute: {
            Id: 0,
            UserId: userId,
            Name: attr?.attribute?.name,
            MapAttrId: attr?.attribute?.id,
            MapAttrName: attr?.attribute?.name,
            CreateDate: new Date().toISOString(),
            UpdateDate: new Date().toISOString(),
            Ia: true,
          },
        },
      };
    });

    return productAttributeList;
  }
  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="60vh"
      >
        <CircularProgress />
      </Box>
    );
  }
  console.log("sendProductResponse", sendProductResponse);
  return (
    <Container maxWidth="lg" sx={{ px: { xs: 1, sm: 2, md: 3 } }}>
      <Paper
        elevation={3}
        sx={{
          p: { xs: 2, sm: 3, md: 4 },
          mt: { xs: 2, sm: 3, md: 4 },
          borderRadius: 2,
          width: "100%",
          overflow: "hidden",
        }}
      >
        <Typography
          variant="h4"
          align="center"
          gutterBottom
          sx={{
            color: "primary.main",
            fontWeight: "bold",
            fontSize: { xs: "1.5rem", sm: "2rem", md: "2.5rem" },
          }}
        >
          Toplu Ürün Gönderme
        </Typography>

        <Stepper
          activeStep={activeStep}
          alternativeLabel
          sx={{
            mt: { xs: 2, sm: 3, md: 4 },
            mb: { xs: 3, sm: 4, md: 6 },
            "& .MuiStepLabel-root .Mui-completed": { color: "success.main" },
            "& .MuiStepLabel-root .Mui-active": { color: "primary.main" },
            "& .MuiStepLabel-label": {
              fontSize: { xs: "0.75rem", sm: "0.875rem", md: "1rem" },
            },
          }}
        >
          {steps.map((label, index) => (
            <Step key={index}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
        <Alert
          sx={{
            mb: 2,
            fontSize: { xs: "0.875rem", sm: "1rem" },
          }}
          severity="info"
        >
          Seçili ürünlerin bir ürünün tüm varyantları seçildiğinden emin olunuz
          eğer bir sonraki gönderimde bir ürünün varyantları 2 ayrı gönderimde
          olursa 2 farklı ürün gibi gönderilir.
        </Alert>
        {error && (
          <Alert
            severity="error"
            sx={{
              mb: 3,
              fontSize: { xs: "0.875rem", sm: "1rem" },
            }}
          >
            {error}
          </Alert>
        )}

        {activeStep === 0 ? (
          <Stack spacing={{ xs: 2, sm: 3, md: 4 }} sx={{ mt: 2 }}>
            <Typography
              variant="h6"
              color="text.secondary"
              sx={{ fontSize: { xs: "1rem", sm: "1.25rem", md: "1.5rem" } }}
            >
              Lütfen pazaryerinizi ve kategorinizi seçiniz
            </Typography>

            <Autocomplete
              options={allPlaces}
              getOptionLabel={(option) => option.name || ""}
              value={selectedPlace}
              onChange={(event, newValue) => setSelectedPlace(newValue)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Pazaryeri veya E-ticaret Platformu"
                  variant="outlined"
                  fullWidth
                  size="medium"
                />
              )}
            />

            <Autocomplete
              options={categories}
              getOptionLabel={(option) => option.name || ""}
              value={selectedCategory}
              onChange={(event, newValue) => setSelectedCategory(newValue)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Kategori Seçiniz"
                  variant="outlined"
                  fullWidth
                  size="medium"
                />
              )}
            />

            <TextField
              size="medium"
              fullWidth
              label="Başlıkta İçeren Metin"
              variant="outlined"
              name="Title"
              value={containsTitle}
              onChange={handleInputChange}
            />

            <Button
              variant="contained"
              size="large"
              onClick={() => {
                getCategoryProducts();
                handleNext();
              }}
              disabled={!canProceedToNextStep}
              sx={{
                mt: { xs: 1, sm: 2 },
                py: { xs: 1, sm: 1.5 },
                px: { xs: 2, sm: 4 },
                backgroundColor: "primary.main",
                borderRadius: 2,
                fontSize: { xs: "0.875rem", sm: "1rem" },
                "&:hover": { backgroundColor: "primary.dark" },
              }}
            >
              Devam
            </Button>
          </Stack>
        ) : activeStep === 1 ? (
          <ProductSelectionStep
            products={products}
            onBack={handleBack}
            onComplete={(selectedProducts) => {
              setSelectedProduct(selectedProducts);
              handleNext();
            }}
            totalCount={totalCount}
            setPage={setPage}
            page={page}
            pageSize={pageSize}
            setPageSize={setPageSize}
            getCategoryProducts={getCategoryProducts}
            selectedProducts={selectedProducts}
            setSelectedProducts={setSelectedProducts}
          />
        ) : activeStep === 2 ? (
          <AttributeSelectionStep
            setSelectedAttributes={setSelectedAttributes}
            onBack={handleBack}
            onComplete={handleNext}
            loading={attributeLoading}
            selectedPlace={selectedPlace}
            accountMarketpleacesName={accountMarketpleacesName}
            categoryAttribute={categoryAttribute}
          />
        ) : (
          <Box sx={{ mt: { xs: 2, sm: 3, md: 4 } }}>
            <Typography
              variant="h5"
              gutterBottom
              color={selectedPlace?.colorCode || "primary.main"}
              sx={{
                fontWeight: 600,
                mb: 3,
                fontSize: { xs: "1.25rem", sm: "1.5rem", md: "1.75rem" },
              }}
            >
              Seçilen Platform: {selectedPlace?.name || "Seçilmedi"}
            </Typography>
            <Paper
              variant="outlined"
              sx={{
                p: { xs: 2, sm: 3, md: 4 },
                mb: { xs: 2, sm: 3, md: 4 },
                backgroundColor: "grey.50",
                borderRadius: 3,
                boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
              }}
            >
              <Typography
                gutterBottom
                color="primary.main"
                sx={{
                  fontWeight: 600,
                  mb: 3,
                  fontSize: { xs: "1.1rem", sm: "1.25rem", md: "1.5rem" },
                }}
              >
                Ürün Gönderme Seçenekleri
              </Typography>

              <Stack spacing={{ xs: 2, sm: 3 }}>
                <Box>
                  <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    startIcon={<SendIcon />}
                    onClick={senProduct}
                    sx={{
                      px: { xs: 2, sm: 4 },
                      py: { xs: 1, sm: 1.5 },
                      borderRadius: 2,
                      textTransform: "none",
                      fontSize: { xs: "0.875rem", sm: "1.1rem" },
                      fontWeight: 500,
                      width: { xs: "100%", sm: "auto" },
                      boxShadow: "0 4px 12px rgba(25, 118, 210, 0.3)",
                      "&:hover": {
                        boxShadow: "0 6px 16px rgba(25, 118, 210, 0.4)",
                        transform: "translateY(-1px)",
                      },
                    }}
                  >
                    Şimdi Gönder
                  </Button>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{
                      mt: 1,
                      ml: 1,
                      fontSize: { xs: "0.75rem", sm: "0.875rem" },
                    }}
                  >
                    İşlem hemen başlar ve ürünlerin gönderim durumunu
                    görebilirsiniz
                  </Typography>
                </Box>

                <Divider sx={{ my: { xs: 1, sm: 2 } }} />

                <Box>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{
                      mb: 1,
                      ml: 1,
                      fontSize: { xs: "0.75rem", sm: "0.875rem" },
                    }}
                  >
                    Sadece E-Ticaret platformlarında geçerlidir
                  </Typography>
                  <Button
                    variant="contained"
                    color="success"
                    size="large"
                    startIcon={<ScheduleIcon />}
                    onClick={openBackGroundModal}
                    disabled={selectedPlace?.type != "ecommerce"}
                    sx={{
                      px: { xs: 2, sm: 4 },
                      py: { xs: 1, sm: 1.5 },
                      borderRadius: 2,
                      textTransform: "none",
                      fontSize: { xs: "0.875rem", sm: "1.1rem" },
                      fontWeight: 500,
                      width: { xs: "100%", sm: "auto" },
                      boxShadow: "0 4px 12px rgba(46, 125, 50, 0.3)",
                      "&:hover": {
                        boxShadow: "0 6px 16px rgba(46, 125, 50, 0.4)",
                        transform: "translateY(-1px)",
                      },
                    }}
                  >
                    Arka Planda Gönder
                  </Button>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{
                      mt: 1,
                      ml: 1,
                      fontSize: { xs: "0.75rem", sm: "0.875rem" },
                    }}
                  >
                    İşlem arka planda devam eder,ürünlerin gönderim durumunu
                    ürün listesinden takip edebilirsiniz
                  </Typography>
                </Box>
              </Stack>
            </Paper>

            <Stack
              direction={{ xs: "column", sm: "row" }}
              spacing={2}
              justifyContent="flex-end"
              sx={{ mt: { xs: 2, sm: 3 } }}
            >
              <Button
                variant="outlined"
                onClick={handleBack}
                fullWidth={false}
                sx={{
                  px: { xs: 2, sm: 4 },
                  borderRadius: 2,
                  width: { xs: "100%", sm: "auto" },
                }}
              >
                Geri
              </Button>
              <Button
                variant="outlined"
                color="error"
                onClick={finish}
                size="large"
                fullWidth={false}
                sx={{
                  px: { xs: 2, sm: 4 },
                  borderRadius: 2,
                  width: { xs: "100%", sm: "auto" },
                }}
              >
                Bitir
              </Button>
            </Stack>
          </Box>
        )}
      </Paper>
      <LoadingSendProductModal
        open={openLoadingModal}
        handleCloseDialog={() => setOpenLoadingModal(false)}
        loadingSendProduct={loadingSendProduct}
        sendProduct={sendProducts}
        sendProductResponse={sendProductResponse}
        marketPlaceName={selectedPlace?.name}
        loadingOutwardSendProduct={loadingOutwardSendProduct}
      />
      <Dialog
        open={bacgroundModal}
        onClose={bacgroundModalClose}
        aria-labelledby="alert-dialog-title"
        fullWidth
        maxWidth="sm"
        PaperProps={{
          sx: {
            width: { xs: "95%", sm: "80%", md: "60%" },
            m: { xs: 1, sm: 2 },
            borderRadius: 2,
          },
        }}
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{
            fontSize: { xs: "1.1rem", sm: "1.25rem", md: "1.5rem" },
          }}
        >
          Uyarı
        </DialogTitle>
        <DialogContent>
          {sendProductResponse ? (
            <TableContainer
              component={Paper}
              sx={{
                maxHeight: { xs: 200, sm: 300 },
                overflow: "auto",
                mt: 1,
              }}
            >
              <Table stickyHeader size="small">
                <TableHead>
                  <TableRow>
                    <TableCell
                      sx={{
                        fontSize: { xs: "0.75rem", sm: "0.875rem" },
                        whiteSpace: "nowrap",
                      }}
                    >
                      Gönderim İşlemi Devam Eden Ürünler
                    </TableCell>
                    <TableCell
                      sx={{
                        fontSize: { xs: "0.75rem", sm: "0.875rem" },
                      }}
                    ></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {sendProducts.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell>
                        {item.productImages && item.productImages.length > 0 ? (
                          <Box
                            component="img"
                            src={item.productImages[0].imageUrl}
                            alt={item.title}
                            sx={{
                              width: { xs: 40, sm: 50 },
                              height: { xs: 40, sm: 50 },
                              objectFit: "contain",
                            }}
                          />
                        ) : (
                          "-"
                        )}
                      </TableCell>
                      <TableCell
                        sx={{
                          fontSize: { xs: "0.75rem", sm: "0.875rem" },
                        }}
                      >
                        {item.title || "-"}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <DialogContentText
              sx={{
                fontSize: { xs: "0.875rem", sm: "1rem" },
              }}
            >
              Ürünleriniz arka planda yüklenecek gönderim durumunu ürün
              listesinden daha sonra kontrol etmeniz gerekecek
              <br />
            </DialogContentText>
          )}
        </DialogContent>
        <DialogActions sx={{ p: { xs: 1, sm: 2 } }}>
          <Button
            onClick={bacgroundModalClose}
            color="primary"
            sx={{
              fontSize: { xs: "0.875rem", sm: "1rem" },
            }}
          >
            Geri
          </Button>
          <Button
            onClick={backGroundSenProduct}
            color="error"
            variant="contained"
            disabled={loadingBacgroundProduct}
            sx={{
              fontSize: { xs: "0.875rem", sm: "1rem" },
            }}
          >
            {loadingBacgroundProduct ? "Gönderiliyor..." : "Gönder"}
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};
